<template>
  <div class="card">
    <h2 class="card__title">
      忘記密碼嗎？
    </h2>
    <FormRow>
      <div :class="$style.formControl">
        <FormLabel>
          聯絡信箱
        </FormLabel>
        <TextInput
          id="email"
          :value.sync="form.email"
          placeholder="請輸入帳號（聯絡信箱）"
        />
      </div>

      <div :class="$style.formControl">
        <Button
          small
          transparent
          @click.native="send"
        >
          確認送出
        </Button>
      </div>
    </FormRow>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
// configs
import errorMessages from '@/configs/errorMessages';
// stores
import memberState from '@/store/modules/member';
// components
import FormRow from '@/components/form/FormRow.vue';
import FormLabel from '@/components/form/FormLabel.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import Button from '@/components/buttons/Button.vue';

export default {
  components: {
    Button,
    FormRow,
    FormLabel,
    TextInput,
  },
  data() {
    return {
      form: {
        email: '',
      },
    };
  },
  beforeCreate() {
    if(this.$store.state.member) {
      return;
    }
    this.$store.registerModule('member', memberState);
  },
  methods: {
    async send() {
      const result = await this.resetPassword({ email: this.form.email });
      if(result) {
        alert('密碼已重設，請至信箱查看新密碼');
      } else {
        alert(errorMessages.defaultMessage);
      }
    },
    ...mapActions('member', [
      'resetPassword',
    ]),
  },
};
</script>

<style lang="scss" module>
  .formControl {
    margin-bottom: 1rem;
  }
</style>
